module.exports = __webpack_public_path__ + "static/media/apo-island.4dcd43e7.jpeg";